import { render, staticRenderFns } from "./PatientSearch.vue?vue&type=template&id=f394f5c0&scoped=true&"
import script from "./PatientSearch.vue?vue&type=script&lang=js&"
export * from "./PatientSearch.vue?vue&type=script&lang=js&"
import style0 from "./PatientSearch.vue?vue&type=style&index=0&id=f394f5c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f394f5c0",
  null
  
)

export default component.exports